import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

export default function LoadingModal(props) {
  
    if (props.show)
    {
        return (
            <div className="allscreen">
                <div className="spinercenter">
                    <Spinner animation="border" variant="primary"/>
                </div>
            </div>
        );
    } else {
        return(<></>);
    }
  }